module.exports = __webpack_public_path__ + "assets/img/btn-application-blue.620df63b.svg";